import axios from '../common/axios.js'
import _ from 'lodash'
import CustomInput from '../common/forms/Input.vue'
import Select from '../common/forms/Select.vue'
import Phone from '../common/forms/Phone.vue'
import Utils from '../common/utils.js'

export default {
	mixins: [Utils],
	data() {
		return {
			user: null,
			errors: {},
			success: false,
			telechargements: {},
			annee: 0,
			telechargement: {},
			noEditSourcings: ['grandest','ecotlctest','ecotlc','refashion']
			// noEditSourcings: ['ecotlctest','ecotlc','refashion']
		}
	},
	created(){
		this.user = _.cloneDeep(this.$store.state.user.user)

		this.user.tel1 = this.user.tel1.replace('=', '')

		let sourcing_id = this.$store.state.ui.sourcing.id;
		let self = this
		axios.get('api=inex/views/connections-credits/{view_code}')
			.then(function (response) {
				if (response.data.annees.length) {
					self.telechargements = response.data
					self.annee = response.data.annees[response.data.annees.length-1]
				}
			}).catch(function (error) {

			})
	},
	methods: {
		checkError(code){
			return 'aaa'
		},
		close_filter(){
			this.$store.commit('UI_SET_CONTENT', {content: 'result'});
		},
		save_user(){
			let self = this

			self.errors = {}

			if(this.user.password && this.user.password.length > 0){
				if(this.password_validator.all == false){
					self.errors.password = this.$t('validate_profil_password_valide');
					return;
				}
			}
			
			let data = new FormData();
			if(this.canEdit && !this.$store.getters.isSSOUser){
				data.append('nom', self.user.nom);
				data.append('prenom', self.user.prenom);
				data.append('email', self.user.email);
				data.append('fonction', self.user.fonction);
				data.append('civilite_id', self.user.civilite_id);
				data.append('tel1', self.user.tel1);
				data.append('password', self.user.password);
				data.append('passwordb', self.user.passwordb);
			}
			data.append('langue', self.user.langue);


			this.$store.commit('UI_SET_SAVE_USER_LOADING', true);

			axios.post('/plugin_projet/plugin_projet_iannuaire/update_user', data)
				.then(function (response) {
					if (response.data == 'OK') {
						self.user.password = ''
						self.user.passwordb = ''
						self.$store.dispatch('update_user', self.user)
						self.success = true
						setTimeout(() => self.success = false, 2000)

						if(self.user.langue != self.$store.state.ui.langue){
							self.$store.commit('UI_SET_LANGUE', self.user.langue);
							self.$store.dispatch('uploadInitApp');
							self.$store.commit('UI_SET_SAVE_USER_LOADING', false);
						}else{
							self.$store.commit('UI_SET_SAVE_USER_LOADING', false);
						}

					} else {
						self.errors = response.data
						self.$store.commit('UI_SET_SAVE_USER_LOADING', false);
					}
				}).catch(function (error) {

				})
		},		
		checkLoginError(){
			axios.get('api=inex/login/error')
		},
		phoneValidation(validation){
			this[validation.field+'_validation'] = validation
		}
	},
	computed:{
		password_validator(){
			console.log('==>', this.user.password);
			if(this.user.password){
				let validations = this._passwordValidator(this.user.password)
				console.log('==>', validations);
				return validations
			}
			return {
				nbr_cars: false,
				majuscule: false,
				chiffre: false,
				special_car: false,
				all: false
			}
		},
		civilite_options(){
			return [
				{label: this.$t('M.'), value: 3},
				{label: this.$t('Mme'), value: 1},
			]
		},
		getTelechargement(){
			return this.annee ? this.telechargements.data_by_years_months[this.annee] : {}
		},
		getTotal1(){
			return this.annee ? this.telechargements.data_by_years[this.annee]['total_month'] : 0;
		},
		getTotal2(){
			return this.annee ? this.telechargements.data_by_years[this.annee]['uniq'] : 0;
		},
		getTotal3(){
			return this.annee ? this.telechargements.data_by_years[this.annee]['new'] : 0;
		},
		canEdit(){
			return true;			
		}
	},
	components:{
		SousMenu: () => import('./sous_menu.vue'),
		CustomInput,
		Select,
		Phone
	}
}